export const MARKER_CIRCLE_DEFAULT_SIZE = 17;

export const MARKER_CIRCLE_STROKE_WIDTH = 4;

export const MARKER_CIRCLE_SCALE = {
  DEFAULT: 1,
  LG: 24 / MARKER_CIRCLE_DEFAULT_SIZE,
  XL: 28 / MARKER_CIRCLE_DEFAULT_SIZE,
};
